//import { useState } from "react";
import axios from "../api/axios";
import useAuth from "./useAuth";
import { checkSiteVersion } from "../utils";
import { useCallback } from "react";

const useRefreshToken = () => {
  const { updateAccessToken, updateWebSocketToken, auth, setAuth} = useAuth();

  return useCallback(async () => {
    const response = await axios.get('/refresh', { withCredentials: true })
    const {accessToken, webSocketToken, username, role} = response.data as ({accessToken:string, webSocketToken:string, username:string, role:"Moderator" | "SuperUser" | "DefaultUser"})
    //const decodedToken = JSON.parse(atob(accessToken.split('.')[1]))

    checkSiteVersion()
    updateAccessToken(accessToken)
    updateWebSocketToken(webSocketToken)
    
    if(!auth) setAuth?.({username, role})
    
    return accessToken
  }, [])
}

export default useRefreshToken